import { z } from "zod";

export const einmaleinsReiheSchema = z.union([
  z.literal(2), z.literal(3), z.literal(4), z.literal(5), z.literal(6),
  z.literal(7), z.literal(8), z.literal(9), z.literal(10),
]);
const einmaleinsAnzahlSchema = z.union([z.literal(5), z.literal(10), z.literal(15), z.literal(20)]);
const einmaleinsDauerSchema = z.union([z.literal(180), z.literal(300), z.literal(600), z.literal(900)]);
const einmaleinsTrainingModeSchema = z.enum(["rows", "core"]);
const einmaleinsReihenSchema = z.array(einmaleinsReiheSchema).max(9).superRefine((rows, context) => {
  if (new Set(rows).size !== rows.length) context.addIssue({ code: "custom", message: "Jede 1×1-Reihe darf nur einmal ausgewählt sein." });
});
export const einmaleinsExerciseConfigSchema = z.object({
  instructions: z.string().min(1).max(2_000),
  defaultRows: einmaleinsReihenSchema.min(1).default([2, 3, 4, 5, 6, 7, 8, 9, 10]),
  defaultTrainingMode: einmaleinsTrainingModeSchema.default("rows"),
  defaultCount: einmaleinsAnzahlSchema.default(10),
  defaultMode: z.enum(["count", "time"]).default("count"),
  defaultDurationSeconds: einmaleinsDauerSchema.default(180),
});
export const einmaleinsRunSettingsSchema = z.object({
  trainingMode: einmaleinsTrainingModeSchema.default("rows"),
  mode: z.enum(["count", "time"]),
  count: einmaleinsAnzahlSchema,
  durationSeconds: einmaleinsDauerSchema,
  rows: einmaleinsReihenSchema.default([]),
}).superRefine((settings, context) => {
  if (settings.trainingMode === "rows" && settings.rows.length === 0) context.addIssue({ code: "custom", path: ["rows"], message: "Wähle mindestens eine 1×1-Reihe aus." });
  if (settings.trainingMode === "core" && settings.rows.length !== 0) context.addIssue({ code: "custom", path: ["rows"], message: "Kernaufgaben verwenden einen festen Aufgabenpool ohne zusätzliche Reihenauswahl." });
});
